import { createTheme } from "@mui/material/styles";
export default (function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return createTheme({
        palette: {
            primary: {
                main: palette.primary.main,
            },
            secondary: {
                main: palette.secondary.main,
            },
        },
        typography: {
            fontFamily: typography.fontFamily,
        },
        components: {
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        width: "100%",
                    },
                },
            },
        },
    });
});
//# sourceMappingURL=theme.js.map